import React from 'react';
import './style.scss';

const PrivateLayout = ({ children }) => {
  return (
    <div className="privateLayout-container">
      <div className="content">{children}</div>
    </div>
  );
};

export default PrivateLayout;
